import React from 'react';
import { Accordion, Image } from 'react-bootstrap';

import CollapseNav from 'components/bars/CollapseNav';
import { tabList } from 'config/NavBarConfig';

import menuLogo from 'assets/images/side_menu_logo.svg';

import './SideMenuNav.scss';

function SideMenuNav() {
  return (
    <div>
      <Image src={menuLogo} className="side-bar-logo" />
      <Accordion className="side-menu-nav-background">
        {tabList.map((tab, index) => (
          <CollapseNav tab={tab} key={`${tab.name}-${index}`} />
        ))}
      </Accordion>
    </div>
  );
}

export default SideMenuNav;
